import React, { useEffect } from "react";

const ContabilidadAsientosPage = () => {
  useEffect(() => {
    document.title = "Contabilidad - Asientos | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Asientos contables</h4>
            <p className="text-muted mb-0">
              Próximamente vas a poder registrar asientos manuales, revisar movimientos pendientes y
              ajustar períodos contables desde esta vista.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContabilidadAsientosPage;
